import { connect } from 'react-redux'
import { isActiveRouteSelector, redirectToApplication } from 'shared/components/Menu/module'
import { popLastBreadcrumbElement } from 'shared/components/Breadcrumb/module'
import { getApplicationsSelector } from 'shared/pages/Company/module'
import ApplicationQuickAccessMenu from './ApplicationQuickAccessMenu.component'

function mapStateToProps (state) {
  return ({
    applications: getApplicationsSelector(
      state, state.company.selectedProduct),
    isActiveApplication: (applicationId) => isActiveRouteSelector(state, applicationId)
  })
}

function mapDispatchToProps (dispatch) {
  return ({
    popLastBreadcrumbElement () {
      dispatch(popLastBreadcrumbElement())
    },
    redirectToApplication (id, name, isPortal) {
      dispatch(redirectToApplication(id, name, isPortal))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationQuickAccessMenu)
